/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-83b9d1f1.js';
import '@carbon/icon-helpers';
import 'prop-types';
import React from 'react';

var didWarnAboutDeprecation = {};

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ChatBot20 = /*#__PURE__*/React.forwardRef(function ChatBot20(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, _ref3, children);
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 19a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0116 19zM20 8a2 2 0 102 2A1.9806 1.9806 0 0020 8zM12 8a2 2 0 102 2A1.9806 1.9806 0 0012 8z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ChatBot16 = /*#__PURE__*/React.forwardRef(function ChatBot16(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref5, _ref6, children);
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox32 = /*#__PURE__*/React.forwardRef(function Checkbox32(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref8, children);
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox24 = /*#__PURE__*/React.forwardRef(function Checkbox24(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref10, children);
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox20 = /*#__PURE__*/React.forwardRef(function Checkbox20(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref12, children);
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var Checkbox16 = /*#__PURE__*/React.forwardRef(function Checkbox16(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref14, children);
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked32 = /*#__PURE__*/React.forwardRef(function CheckboxChecked32(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref16, _ref17, children);
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked24 = /*#__PURE__*/React.forwardRef(function CheckboxChecked24(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref19, _ref20, children);
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked20 = /*#__PURE__*/React.forwardRef(function CheckboxChecked20(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref22, _ref23, children);
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
});

var CheckboxChecked16 = /*#__PURE__*/React.forwardRef(function CheckboxChecked16(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref25, _ref26, children);
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled32 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled32(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref28, _ref29, children);
});

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled24 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled24(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref31, _ref32, children);
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref35 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled20 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled20(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref34, _ref35, children);
});

var _ref37 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
  "data-icon-path": "inner-path"
});

var CheckboxCheckedFilled16 = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled16(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref37, _ref38, children);
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref41 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate32 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate32(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref40, _ref41, children);
});

var _ref43 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate24 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate24(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref43, _ref44, children);
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref47 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate20 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate20(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref46, _ref47, children);
});

var _ref49 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxIndeterminate16 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate16(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref49, _ref50, children);
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref53 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled32 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled32(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref52, _ref53, children);
});

var _ref55 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled24 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled24(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref55, _ref56, children);
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref59 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled20 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled20(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref58, _ref59, children);
});

var _ref61 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M22,18H10V14H22Z",
  "data-icon-path": "inner-path"
});

var CheckboxIndeterminateFilled16 = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled16(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref61, _ref62, children);
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref65 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate32 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate32(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate32']) {
      didWarnAboutDeprecation['CheckboxUndeterminate32'] = true;
      console.warn("The CheckboxUndeterminate32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref64, _ref65, children);
});

var _ref67 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate24 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate24(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate24']) {
      didWarnAboutDeprecation['CheckboxUndeterminate24'] = true;
      console.warn("The CheckboxUndeterminate24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref67, _ref68, children);
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref71 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate20 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate20(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate20']) {
      didWarnAboutDeprecation['CheckboxUndeterminate20'] = true;
      console.warn("The CheckboxUndeterminate20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref70, _ref71, children);
});

var _ref73 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 14H22V18H10z"
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
});

var CheckboxUndeterminate16 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminate16(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminate16']) {
      didWarnAboutDeprecation['CheckboxUndeterminate16'] = true;
      console.warn("The CheckboxUndeterminate16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref73, _ref74, children);
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled32 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled32(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled32']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled32'] = true;
      console.warn("The CheckboxUndeterminateFilled32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref76, children);
});

var _ref78 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled24 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled24(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled24']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled24'] = true;
      console.warn("The CheckboxUndeterminateFilled24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref78, children);
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled20 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled20(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled20']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled20'] = true;
      console.warn("The CheckboxUndeterminateFilled20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref80, children);
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
});

var CheckboxUndeterminateFilled16 = /*#__PURE__*/React.forwardRef(function CheckboxUndeterminateFilled16(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CheckboxUndeterminateFilled16']) {
      didWarnAboutDeprecation['CheckboxUndeterminateFilled16'] = true;
      console.warn("The CheckboxUndeterminateFilled16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref82, children);
});

var _ref84 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
});

var Checkmark32 = /*#__PURE__*/React.forwardRef(function Checkmark32(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref84, children);
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
});

var Checkmark24 = /*#__PURE__*/React.forwardRef(function Checkmark24(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref86, children);
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
});

var _ref89 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
});

var Checkmark20 = /*#__PURE__*/React.forwardRef(function Checkmark20(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref88, _ref89, children);
});

var _ref91 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
});

var Checkmark16 = /*#__PURE__*/React.forwardRef(function Checkmark16(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref91, children);
});

var _ref93 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
  "data-icon-path": "inner-path"
});

var CheckmarkFilled32 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled32(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref93, _ref94, children);
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
});

var _ref97 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CheckmarkFilled24 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled24(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref96, _ref97, children);
});

var _ref99 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CheckmarkFilled20 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled20(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref99, _ref100, children);
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
});

var _ref103 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CheckmarkFilled16 = /*#__PURE__*/React.forwardRef(function CheckmarkFilled16(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref102, _ref103, children);
});

var _ref105 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref106 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref107 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError32 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError32(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref105, _ref106, _ref107, children);
});

var _ref109 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref111 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError24 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError24(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref109, _ref110, _ref111, children);
});

var _ref113 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref115 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError20 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError20(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref113, _ref114, _ref115, children);
});

var _ref117 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
});

var _ref118 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref119 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledError16 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError16(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref117, _ref118, _ref119, children);
});

var _ref121 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref123 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning32 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning32(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref121, _ref122, _ref123, children);
});

var _ref125 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref127 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning24 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning24(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref125, _ref126, _ref127, children);
});

var _ref129 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref130 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref131 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning20 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning20(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref129, _ref130, _ref131, children);
});

var _ref133 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
});

var _ref134 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
});

var _ref135 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z"
});

var CheckmarkFilledWarning16 = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning16(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref133, _ref134, _ref135, children);
});

var _ref137 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref138 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline32 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline32(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref137, _ref138, children);
});

var _ref140 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref141 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline24 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline24(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref140, _ref141, children);
});

var _ref143 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref144 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline20 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline20(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref143, _ref144, children);
});

var _ref146 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
});

var _ref147 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
});

var CheckmarkOutline16 = /*#__PURE__*/React.forwardRef(function CheckmarkOutline16(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref146, _ref147, children);
});

var _ref149 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref150 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError32 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError32(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref149, _ref150, children);
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref153 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError24 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError24(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref152, _ref153, children);
});

var _ref155 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref156 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError20 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError20(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref155, _ref156, children);
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref159 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
});

var CheckmarkOutlineError16 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError16(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref158, _ref159, children);
});

var _ref161 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref162 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning32 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning32(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref161, _ref162, children);
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref165 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning24 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning24(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref164, _ref165, children);
});

var _ref167 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning20 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning20(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref167, _ref168, children);
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
});

var _ref171 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
});

var CheckmarkOutlineWarning16 = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning16(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref170, _ref171, children);
});

var _ref173 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry32 = /*#__PURE__*/React.forwardRef(function Chemistry32(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref173, children);
});

var _ref175 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry24 = /*#__PURE__*/React.forwardRef(function Chemistry24(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref175, children);
});

var _ref177 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry20 = /*#__PURE__*/React.forwardRef(function Chemistry20(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref177, children);
});

var _ref179 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
});

var Chemistry16 = /*#__PURE__*/React.forwardRef(function Chemistry16(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref179, children);
});

var _ref181 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref182 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference32 = /*#__PURE__*/React.forwardRef(function ChemistryReference32(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref181, _ref182, children);
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref185 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference24 = /*#__PURE__*/React.forwardRef(function ChemistryReference24(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref184, _ref185, children);
});

var _ref187 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref188 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference20 = /*#__PURE__*/React.forwardRef(function ChemistryReference20(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref187, _ref188, children);
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
});

var _ref191 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
});

var ChemistryReference16 = /*#__PURE__*/React.forwardRef(function ChemistryReference16(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref190, _ref191, children);
});

var _ref193 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
});

var ChevronDown32 = /*#__PURE__*/React.forwardRef(function ChevronDown32(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref193, children);
});

var _ref195 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
});

var ChevronDown24 = /*#__PURE__*/React.forwardRef(function ChevronDown24(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref195, children);
});

var _ref197 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
});

var ChevronDown20 = /*#__PURE__*/React.forwardRef(function ChevronDown20(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref197, children);
});

var _ref199 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
});

var ChevronDown16 = /*#__PURE__*/React.forwardRef(function ChevronDown16(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref199, children);
});

var _ref201 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
});

var ChevronDownGlyph = /*#__PURE__*/React.forwardRef(function ChevronDownGlyph(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref201, children);
});

var _ref203 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
});

var ChevronLeft32 = /*#__PURE__*/React.forwardRef(function ChevronLeft32(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref203, children);
});

var _ref205 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
});

var ChevronLeft24 = /*#__PURE__*/React.forwardRef(function ChevronLeft24(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref205, children);
});

var _ref207 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
});

var ChevronLeft20 = /*#__PURE__*/React.forwardRef(function ChevronLeft20(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref207, children);
});

var _ref209 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
});

var ChevronLeft16 = /*#__PURE__*/React.forwardRef(function ChevronLeft16(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref209, children);
});

var _ref211 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
});

var ChevronLeftGlyph = /*#__PURE__*/React.forwardRef(function ChevronLeftGlyph(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref211, children);
});

var _ref213 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 19L31 31 19 31z"
});

var ChevronMini32 = /*#__PURE__*/React.forwardRef(function ChevronMini32(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref213, children);
});

var _ref215 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 19L31 31 19 31z"
});

var ChevronMini24 = /*#__PURE__*/React.forwardRef(function ChevronMini24(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref215, children);
});

var _ref217 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 19L31 31 19 31z"
});

var ChevronMini20 = /*#__PURE__*/React.forwardRef(function ChevronMini20(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref217, children);
});

var _ref219 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 9L15 15 9 15z"
});

var ChevronMini16 = /*#__PURE__*/React.forwardRef(function ChevronMini16(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref219, children);
});

var _ref221 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
});

var ChevronRight32 = /*#__PURE__*/React.forwardRef(function ChevronRight32(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref221, children);
});

var _ref223 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
});

var ChevronRight24 = /*#__PURE__*/React.forwardRef(function ChevronRight24(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref223, children);
});

var _ref225 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
});

var ChevronRight20 = /*#__PURE__*/React.forwardRef(function ChevronRight20(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref225, children);
});

var _ref227 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
});

var ChevronRight16 = /*#__PURE__*/React.forwardRef(function ChevronRight16(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref227, children);
});

var _ref229 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
});

var ChevronRightGlyph = /*#__PURE__*/React.forwardRef(function ChevronRightGlyph(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref229, children);
});

var _ref231 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
});

var ChevronSort32 = /*#__PURE__*/React.forwardRef(function ChevronSort32(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref231, children);
});

var _ref233 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
});

var ChevronSort24 = /*#__PURE__*/React.forwardRef(function ChevronSort24(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref233, children);
});

var _ref235 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
});

var ChevronSort20 = /*#__PURE__*/React.forwardRef(function ChevronSort20(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref235, children);
});

var _ref237 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
});

var ChevronSort16 = /*#__PURE__*/React.forwardRef(function ChevronSort16(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref237, children);
});

var _ref239 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
});

var ChevronSortDown32 = /*#__PURE__*/React.forwardRef(function ChevronSortDown32(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref239, children);
});

var _ref241 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
});

var ChevronSortDown24 = /*#__PURE__*/React.forwardRef(function ChevronSortDown24(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref241, children);
});

var _ref243 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
});

var ChevronSortDown20 = /*#__PURE__*/React.forwardRef(function ChevronSortDown20(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref243, children);
});

var _ref245 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
});

var ChevronSortDown16 = /*#__PURE__*/React.forwardRef(function ChevronSortDown16(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref245, children);
});

var _ref247 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
});

var ChevronSortUp32 = /*#__PURE__*/React.forwardRef(function ChevronSortUp32(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref247, children);
});

var _ref249 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
});

var ChevronSortUp24 = /*#__PURE__*/React.forwardRef(function ChevronSortUp24(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref249, children);
});

var _ref251 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
});

var ChevronSortUp20 = /*#__PURE__*/React.forwardRef(function ChevronSortUp20(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref251, children);
});

var _ref253 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
});

var ChevronSortUp16 = /*#__PURE__*/React.forwardRef(function ChevronSortUp16(_ref252, ref) {
  var children = _ref252.children,
      rest = _objectWithoutProperties(_ref252, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref253, children);
});

var _ref255 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
});

var ChevronUp32 = /*#__PURE__*/React.forwardRef(function ChevronUp32(_ref254, ref) {
  var children = _ref254.children,
      rest = _objectWithoutProperties(_ref254, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref255, children);
});

var _ref257 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
});

var ChevronUp24 = /*#__PURE__*/React.forwardRef(function ChevronUp24(_ref256, ref) {
  var children = _ref256.children,
      rest = _objectWithoutProperties(_ref256, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref257, children);
});

var _ref259 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
});

var ChevronUp20 = /*#__PURE__*/React.forwardRef(function ChevronUp20(_ref258, ref) {
  var children = _ref258.children,
      rest = _objectWithoutProperties(_ref258, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref259, children);
});

var _ref261 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
});

var ChevronUp16 = /*#__PURE__*/React.forwardRef(function ChevronUp16(_ref260, ref) {
  var children = _ref260.children,
      rest = _objectWithoutProperties(_ref260, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref261, children);
});

var _ref263 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
});

var ChevronUpGlyph = /*#__PURE__*/React.forwardRef(function ChevronUpGlyph(_ref262, ref) {
  var children = _ref262.children,
      rest = _objectWithoutProperties(_ref262, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref263, children);
});

var _ref265 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref266 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip32 = /*#__PURE__*/React.forwardRef(function Chip32(_ref264, ref) {
  var children = _ref264.children,
      rest = _objectWithoutProperties(_ref264, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref265, _ref266, children);
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref269 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip24 = /*#__PURE__*/React.forwardRef(function Chip24(_ref267, ref) {
  var children = _ref267.children,
      rest = _objectWithoutProperties(_ref267, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref268, _ref269, children);
});

var _ref271 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref272 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip20 = /*#__PURE__*/React.forwardRef(function Chip20(_ref270, ref) {
  var children = _ref270.children,
      rest = _objectWithoutProperties(_ref270, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref271, _ref272, children);
});

var _ref274 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11,11V21H21V11Zm8,8H13V13h6Z"
});

var _ref275 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
});

var Chip16 = /*#__PURE__*/React.forwardRef(function Chip16(_ref273, ref) {
  var children = _ref273.children,
      rest = _objectWithoutProperties(_ref273, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref274, _ref275, children);
});

var _ref277 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 4L21 6 24.586 6 16 14.586 7.414 6 11 6 11 4 4 4 4 11 6 11 6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 11 28 11 28 4 21 4z"
});

var Choices32 = /*#__PURE__*/React.forwardRef(function Choices32(_ref276, ref) {
  var children = _ref276.children,
      rest = _objectWithoutProperties(_ref276, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref277, children);
});

var _ref279 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 4L21 6 24.586 6 16 14.586 7.414 6 11 6 11 4 4 4 4 11 6 11 6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 11 28 11 28 4 21 4z"
});

var Choices24 = /*#__PURE__*/React.forwardRef(function Choices24(_ref278, ref) {
  var children = _ref278.children,
      rest = _objectWithoutProperties(_ref278, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref279, children);
});

var _ref281 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 4L21 6 24.586 6 16 14.586 7.414 6 11 6 11 4 4 4 4 11 6 11 6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 11 28 11 28 4 21 4z"
});

var Choices20 = /*#__PURE__*/React.forwardRef(function Choices20(_ref280, ref) {
  var children = _ref280.children,
      rest = _objectWithoutProperties(_ref280, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref281, children);
});

var _ref283 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21 4L21 6 24.586 6 16 14.586 7.414 6 11 6 11 4 4 4 4 11 6 11 6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 11 28 11 28 4 21 4z"
});

var Choices16 = /*#__PURE__*/React.forwardRef(function Choices16(_ref282, ref) {
  var children = _ref282.children,
      rest = _objectWithoutProperties(_ref282, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref283, children);
});

var _ref285 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref286 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled32 = /*#__PURE__*/React.forwardRef(function CircleFilled32(_ref284, ref) {
  var children = _ref284.children,
      rest = _objectWithoutProperties(_ref284, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref285, _ref286, children);
});

var _ref288 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref289 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled24 = /*#__PURE__*/React.forwardRef(function CircleFilled24(_ref287, ref) {
  var children = _ref287.children,
      rest = _objectWithoutProperties(_ref287, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref288, _ref289, children);
});

var _ref291 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled20 = /*#__PURE__*/React.forwardRef(function CircleFilled20(_ref290, ref) {
  var children = _ref290.children,
      rest = _objectWithoutProperties(_ref290, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref291, _ref292, children);
});

var _ref294 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "10"
});

var _ref295 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
});

var CircleFilled16 = /*#__PURE__*/React.forwardRef(function CircleFilled16(_ref293, ref) {
  var children = _ref293.children,
      rest = _objectWithoutProperties(_ref293, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref294, _ref295, children);
});

var _ref297 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash32 = /*#__PURE__*/React.forwardRef(function CircleDash32(_ref296, ref) {
  var children = _ref296.children,
      rest = _objectWithoutProperties(_ref296, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref297, children);
});

var _ref299 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash24 = /*#__PURE__*/React.forwardRef(function CircleDash24(_ref298, ref) {
  var children = _ref298.children,
      rest = _objectWithoutProperties(_ref298, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref299, children);
});

var _ref301 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash20 = /*#__PURE__*/React.forwardRef(function CircleDash20(_ref300, ref) {
  var children = _ref300.children,
      rest = _objectWithoutProperties(_ref300, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref301, children);
});

var _ref303 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
});

var CircleDash16 = /*#__PURE__*/React.forwardRef(function CircleDash16(_ref302, ref) {
  var children = _ref302.children,
      rest = _objectWithoutProperties(_ref302, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref303, children);
});

var _ref305 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref306 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement32 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement32(_ref304, ref) {
  var children = _ref304.children,
      rest = _objectWithoutProperties(_ref304, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref305, _ref306, children);
});

var _ref308 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref309 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement24 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement24(_ref307, ref) {
  var children = _ref307.children,
      rest = _objectWithoutProperties(_ref307, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref308, _ref309, children);
});

var _ref311 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref312 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement20 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement20(_ref310, ref) {
  var children = _ref310.children,
      rest = _objectWithoutProperties(_ref310, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref311, _ref312, children);
});

var _ref314 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
});

var _ref315 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
});

var WatsonHealthCircleMeasurement16 = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement16(_ref313, ref) {
  var children = _ref313.children,
      rest = _objectWithoutProperties(_ref313, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref314, _ref315, children);
});

var _ref317 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking32 = /*#__PURE__*/React.forwardRef(function CirclePacking32(_ref316, ref) {
  var children = _ref316.children,
      rest = _objectWithoutProperties(_ref316, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref317, children);
});

var _ref319 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking24 = /*#__PURE__*/React.forwardRef(function CirclePacking24(_ref318, ref) {
  var children = _ref318.children,
      rest = _objectWithoutProperties(_ref318, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref319, children);
});

var _ref321 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking20 = /*#__PURE__*/React.forwardRef(function CirclePacking20(_ref320, ref) {
  var children = _ref320.children,
      rest = _objectWithoutProperties(_ref320, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref321, children);
});

var _ref323 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
});

var CirclePacking16 = /*#__PURE__*/React.forwardRef(function CirclePacking16(_ref322, ref) {
  var children = _ref322.children,
      rest = _objectWithoutProperties(_ref322, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref323, children);
});

var _ref325 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer32 = /*#__PURE__*/React.forwardRef(function QCircuitComposer32(_ref324, ref) {
  var children = _ref324.children,
      rest = _objectWithoutProperties(_ref324, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref325, _ref326, children);
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref329 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer24 = /*#__PURE__*/React.forwardRef(function QCircuitComposer24(_ref327, ref) {
  var children = _ref327.children,
      rest = _objectWithoutProperties(_ref327, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref328, _ref329, children);
});

var _ref331 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref332 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer20 = /*#__PURE__*/React.forwardRef(function QCircuitComposer20(_ref330, ref) {
  var children = _ref330.children,
      rest = _objectWithoutProperties(_ref330, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref331, _ref332, children);
});

var _ref334 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
});

var _ref335 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
});

var QCircuitComposer16 = /*#__PURE__*/React.forwardRef(function QCircuitComposer16(_ref333, ref) {
  var children = _ref333.children,
      rest = _objectWithoutProperties(_ref333, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref334, _ref335, children);
});

var _ref337 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref338 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification32 = /*#__PURE__*/React.forwardRef(function Classification32(_ref336, ref) {
  var children = _ref336.children,
      rest = _objectWithoutProperties(_ref336, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref337, _ref338, children);
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref341 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification24 = /*#__PURE__*/React.forwardRef(function Classification24(_ref339, ref) {
  var children = _ref339.children,
      rest = _objectWithoutProperties(_ref339, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref340, _ref341, children);
});

var _ref343 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref344 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification20 = /*#__PURE__*/React.forwardRef(function Classification20(_ref342, ref) {
  var children = _ref342.children,
      rest = _objectWithoutProperties(_ref342, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref343, _ref344, children);
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "15",
  cy: "19",
  r: "1"
});

var _ref347 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
});

var Classification16 = /*#__PURE__*/React.forwardRef(function Classification16(_ref345, ref) {
  var children = _ref345.children,
      rest = _objectWithoutProperties(_ref345, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref346, _ref347, children);
});

var _ref349 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage32 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage32(_ref348, ref) {
  var children = _ref348.children,
      rest = _objectWithoutProperties(_ref348, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref349, children);
});

var _ref351 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage24 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage24(_ref350, ref) {
  var children = _ref350.children,
      rest = _objectWithoutProperties(_ref350, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref351, children);
});

var _ref353 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage20 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage20(_ref352, ref) {
  var children = _ref352.children,
      rest = _objectWithoutProperties(_ref352, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref353, children);
});

var _ref355 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
});

var ClassifierLanguage16 = /*#__PURE__*/React.forwardRef(function ClassifierLanguage16(_ref354, ref) {
  var children = _ref354.children,
      rest = _objectWithoutProperties(_ref354, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref355, children);
});

var _ref357 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref358 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref359 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref360 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean32 = /*#__PURE__*/React.forwardRef(function Clean32(_ref356, ref) {
  var children = _ref356.children,
      rest = _objectWithoutProperties(_ref356, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref357, _ref358, _ref359, _ref360, children);
});

var _ref362 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref363 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref364 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref365 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean24 = /*#__PURE__*/React.forwardRef(function Clean24(_ref361, ref) {
  var children = _ref361.children,
      rest = _objectWithoutProperties(_ref361, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref362, _ref363, _ref364, _ref365, children);
});

var _ref367 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref368 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref369 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref370 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean20 = /*#__PURE__*/React.forwardRef(function Clean20(_ref366, ref) {
  var children = _ref366.children,
      rest = _objectWithoutProperties(_ref366, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref367, _ref368, _ref369, _ref370, children);
});

var _ref372 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 18H26V20H20z",
  transform: "rotate(-180 23 19)"
});

var _ref373 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 26H30V28H24z",
  transform: "rotate(-180 27 27)"
});

var _ref374 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 22H28V24H22z",
  transform: "rotate(-180 25 23)"
});

var _ref375 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
});

var Clean16 = /*#__PURE__*/React.forwardRef(function Clean16(_ref371, ref) {
  var children = _ref371.children,
      rest = _objectWithoutProperties(_ref371, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref372, _ref373, _ref374, _ref375, children);
});

var _ref377 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close32 = /*#__PURE__*/React.forwardRef(function Close32(_ref376, ref) {
  var children = _ref376.children,
      rest = _objectWithoutProperties(_ref376, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref377, children);
});

var _ref379 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close24 = /*#__PURE__*/React.forwardRef(function Close24(_ref378, ref) {
  var children = _ref378.children,
      rest = _objectWithoutProperties(_ref378, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref379, children);
});

var _ref381 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close20 = /*#__PURE__*/React.forwardRef(function Close20(_ref380, ref) {
  var children = _ref380.children,
      rest = _objectWithoutProperties(_ref380, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref381, children);
});

var _ref383 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4 14.6 16 8 22.6 9.4 24 16 17.4 22.6 24 24 22.6 17.4 16 24 9.4z"
});

var Close16 = /*#__PURE__*/React.forwardRef(function Close16(_ref382, ref) {
  var children = _ref382.children,
      rest = _objectWithoutProperties(_ref382, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref383, children);
});

var _ref385 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
});

var _ref386 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CloseFilled32 = /*#__PURE__*/React.forwardRef(function CloseFilled32(_ref384, ref) {
  var children = _ref384.children,
      rest = _objectWithoutProperties(_ref384, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref385, _ref386, children);
});

var _ref388 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
});

var _ref389 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CloseFilled24 = /*#__PURE__*/React.forwardRef(function CloseFilled24(_ref387, ref) {
  var children = _ref387.children,
      rest = _objectWithoutProperties(_ref387, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref388, _ref389, children);
});

var _ref391 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
});

var _ref392 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
  "data-icon-path": "inner-path",
  opacity: "0"
});

var CloseFilled20 = /*#__PURE__*/React.forwardRef(function CloseFilled20(_ref390, ref) {
  var children = _ref390.children,
      rest = _objectWithoutProperties(_ref390, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref391, _ref392, children);
});

var _ref394 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2\tl2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
});

var CloseFilled16 = /*#__PURE__*/React.forwardRef(function CloseFilled16(_ref393, ref) {
  var children = _ref393.children,
      rest = _objectWithoutProperties(_ref393, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref394, children);
});

var _ref396 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref397 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline32 = /*#__PURE__*/React.forwardRef(function CloseOutline32(_ref395, ref) {
  var children = _ref395.children,
      rest = _objectWithoutProperties(_ref395, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref396, _ref397, children);
});

var _ref399 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref400 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline24 = /*#__PURE__*/React.forwardRef(function CloseOutline24(_ref398, ref) {
  var children = _ref398.children,
      rest = _objectWithoutProperties(_ref398, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref399, _ref400, children);
});

var _ref402 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref403 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline20 = /*#__PURE__*/React.forwardRef(function CloseOutline20(_ref401, ref) {
  var children = _ref401.children,
      rest = _objectWithoutProperties(_ref401, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref402, _ref403, children);
});

var _ref405 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12\tS22.6,28,16,28z"
});

var _ref406 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
});

var CloseOutline16 = /*#__PURE__*/React.forwardRef(function CloseOutline16(_ref404, ref) {
  var children = _ref404.children,
      rest = _objectWithoutProperties(_ref404, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref405, _ref406, children);
});

var _ref408 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref409 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption32 = /*#__PURE__*/React.forwardRef(function ClosedCaption32(_ref407, ref) {
  var children = _ref407.children,
      rest = _objectWithoutProperties(_ref407, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref408, _ref409, children);
});

var _ref411 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref412 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption24 = /*#__PURE__*/React.forwardRef(function ClosedCaption24(_ref410, ref) {
  var children = _ref410.children,
      rest = _objectWithoutProperties(_ref410, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref411, _ref412, children);
});

var _ref414 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref415 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption20 = /*#__PURE__*/React.forwardRef(function ClosedCaption20(_ref413, ref) {
  var children = _ref413.children,
      rest = _objectWithoutProperties(_ref413, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref414, _ref415, children);
});

var _ref417 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
});

var _ref418 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
});

var ClosedCaption16 = /*#__PURE__*/React.forwardRef(function ClosedCaption16(_ref416, ref) {
  var children = _ref416.children,
      rest = _objectWithoutProperties(_ref416, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref417, _ref418, children);
});

var _ref420 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref421 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt32 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt32(_ref419, ref) {
  var children = _ref419.children,
      rest = _objectWithoutProperties(_ref419, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref420, _ref421, children);
});

var _ref423 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt24 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt24(_ref422, ref) {
  var children = _ref422.children,
      rest = _objectWithoutProperties(_ref422, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref423, _ref424, children);
});

var _ref426 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref427 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt20 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt20(_ref425, ref) {
  var children = _ref425.children,
      rest = _objectWithoutProperties(_ref425, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref426, _ref427, children);
});

var _ref429 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
});

var ClosedCaptionAlt16 = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt16(_ref428, ref) {
  var children = _ref428.children,
      rest = _objectWithoutProperties(_ref428, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref429, _ref430, children);
});

var _ref432 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled32 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled32(_ref431, ref) {
  var children = _ref431.children,
      rest = _objectWithoutProperties(_ref431, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref432, children);
});

var _ref434 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled24 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled24(_ref433, ref) {
  var children = _ref433.children,
      rest = _objectWithoutProperties(_ref433, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref434, children);
});

var _ref436 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled20 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled20(_ref435, ref) {
  var children = _ref435.children,
      rest = _objectWithoutProperties(_ref435, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref436, children);
});

var _ref438 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
});

var ClosedCaptionFilled16 = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled16(_ref437, ref) {
  var children = _ref437.children,
      rest = _objectWithoutProperties(_ref437, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref438, children);
});

var _ref440 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud32 = /*#__PURE__*/React.forwardRef(function Cloud32(_ref439, ref) {
  var children = _ref439.children,
      rest = _objectWithoutProperties(_ref439, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref440, children);
});

var _ref442 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud24 = /*#__PURE__*/React.forwardRef(function Cloud24(_ref441, ref) {
  var children = _ref441.children,
      rest = _objectWithoutProperties(_ref441, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref442, children);
});

var _ref444 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud20 = /*#__PURE__*/React.forwardRef(function Cloud20(_ref443, ref) {
  var children = _ref443.children,
      rest = _objectWithoutProperties(_ref443, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref444, children);
});

var _ref446 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var Cloud16 = /*#__PURE__*/React.forwardRef(function Cloud16(_ref445, ref) {
  var children = _ref445.children,
      rest = _objectWithoutProperties(_ref445, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref446, children);
});

var _ref448 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps32 = /*#__PURE__*/React.forwardRef(function CloudDataOps32(_ref447, ref) {
  var children = _ref447.children,
      rest = _objectWithoutProperties(_ref447, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref448, children);
});

var _ref450 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps24 = /*#__PURE__*/React.forwardRef(function CloudDataOps24(_ref449, ref) {
  var children = _ref449.children,
      rest = _objectWithoutProperties(_ref449, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref450, children);
});

var _ref452 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps20 = /*#__PURE__*/React.forwardRef(function CloudDataOps20(_ref451, ref) {
  var children = _ref451.children,
      rest = _objectWithoutProperties(_ref451, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref452, children);
});

var _ref454 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
});

var CloudDataOps16 = /*#__PURE__*/React.forwardRef(function CloudDataOps16(_ref453, ref) {
  var children = _ref453.children,
      rest = _objectWithoutProperties(_ref453, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref454, children);
});

var _ref456 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref457 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload32 = /*#__PURE__*/React.forwardRef(function CloudDownload32(_ref455, ref) {
  var children = _ref455.children,
      rest = _objectWithoutProperties(_ref455, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref456, _ref457, children);
});

var _ref459 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref460 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload24 = /*#__PURE__*/React.forwardRef(function CloudDownload24(_ref458, ref) {
  var children = _ref458.children,
      rest = _objectWithoutProperties(_ref458, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref459, _ref460, children);
});

var _ref462 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref463 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload20 = /*#__PURE__*/React.forwardRef(function CloudDownload20(_ref461, ref) {
  var children = _ref461.children,
      rest = _objectWithoutProperties(_ref461, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref462, _ref463, children);
});

var _ref465 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var _ref466 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
});

var CloudDownload16 = /*#__PURE__*/React.forwardRef(function CloudDownload16(_ref464, ref) {
  var children = _ref464.children,
      rest = _objectWithoutProperties(_ref464, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref465, _ref466, children);
});

var _ref468 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning32 = /*#__PURE__*/React.forwardRef(function CloudLightning32(_ref467, ref) {
  var children = _ref467.children,
      rest = _objectWithoutProperties(_ref467, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning32']) {
      didWarnAboutDeprecation['CloudLightning32'] = true;
      console.warn("The CloudLightning32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref468, children);
});

var _ref470 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning24 = /*#__PURE__*/React.forwardRef(function CloudLightning24(_ref469, ref) {
  var children = _ref469.children,
      rest = _objectWithoutProperties(_ref469, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning24']) {
      didWarnAboutDeprecation['CloudLightning24'] = true;
      console.warn("The CloudLightning24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref470, children);
});

var _ref472 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning20 = /*#__PURE__*/React.forwardRef(function CloudLightning20(_ref471, ref) {
  var children = _ref471.children,
      rest = _objectWithoutProperties(_ref471, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning20']) {
      didWarnAboutDeprecation['CloudLightning20'] = true;
      console.warn("The CloudLightning20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref472, children);
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
});

var CloudLightning16 = /*#__PURE__*/React.forwardRef(function CloudLightning16(_ref473, ref) {
  var children = _ref473.children,
      rest = _objectWithoutProperties(_ref473, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudLightning16']) {
      didWarnAboutDeprecation['CloudLightning16'] = true;
      console.warn("The CloudLightning16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref474, children);
});

var _ref476 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain32 = /*#__PURE__*/React.forwardRef(function CloudRain32(_ref475, ref) {
  var children = _ref475.children,
      rest = _objectWithoutProperties(_ref475, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain32']) {
      didWarnAboutDeprecation['CloudRain32'] = true;
      console.warn("The CloudRain32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref476, children);
});

var _ref478 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain24 = /*#__PURE__*/React.forwardRef(function CloudRain24(_ref477, ref) {
  var children = _ref477.children,
      rest = _objectWithoutProperties(_ref477, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain24']) {
      didWarnAboutDeprecation['CloudRain24'] = true;
      console.warn("The CloudRain24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref478, children);
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain20 = /*#__PURE__*/React.forwardRef(function CloudRain20(_ref479, ref) {
  var children = _ref479.children,
      rest = _objectWithoutProperties(_ref479, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain20']) {
      didWarnAboutDeprecation['CloudRain20'] = true;
      console.warn("The CloudRain20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref480, children);
});

var _ref482 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
});

var CloudRain16 = /*#__PURE__*/React.forwardRef(function CloudRain16(_ref481, ref) {
  var children = _ref481.children,
      rest = _objectWithoutProperties(_ref481, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudRain16']) {
      didWarnAboutDeprecation['CloudRain16'] = true;
      console.warn("The CloudRain16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref482, children);
});

var _ref484 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow32 = /*#__PURE__*/React.forwardRef(function CloudSnow32(_ref483, ref) {
  var children = _ref483.children,
      rest = _objectWithoutProperties(_ref483, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow32']) {
      didWarnAboutDeprecation['CloudSnow32'] = true;
      console.warn("The CloudSnow32 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref484, children);
});

var _ref486 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow24 = /*#__PURE__*/React.forwardRef(function CloudSnow24(_ref485, ref) {
  var children = _ref485.children,
      rest = _objectWithoutProperties(_ref485, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow24']) {
      didWarnAboutDeprecation['CloudSnow24'] = true;
      console.warn("The CloudSnow24 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref486, children);
});

var _ref488 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow20 = /*#__PURE__*/React.forwardRef(function CloudSnow20(_ref487, ref) {
  var children = _ref487.children,
      rest = _objectWithoutProperties(_ref487, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow20']) {
      didWarnAboutDeprecation['CloudSnow20'] = true;
      console.warn("The CloudSnow20 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref488, children);
});

var _ref490 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05zM26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05zM19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
});

var CloudSnow16 = /*#__PURE__*/React.forwardRef(function CloudSnow16(_ref489, ref) {
  var children = _ref489.children,
      rest = _objectWithoutProperties(_ref489, ["children"]);

  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation['CloudSnow16']) {
      didWarnAboutDeprecation['CloudSnow16'] = true;
      console.warn("The CloudSnow16 component has been deprecated and will be " + "removed in the next major version of @carbon/icons-react.");
    }
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref490, children);
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref493 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload32 = /*#__PURE__*/React.forwardRef(function CloudUpload32(_ref491, ref) {
  var children = _ref491.children,
      rest = _objectWithoutProperties(_ref491, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref492, _ref493, children);
});

var _ref495 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref496 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload24 = /*#__PURE__*/React.forwardRef(function CloudUpload24(_ref494, ref) {
  var children = _ref494.children,
      rest = _objectWithoutProperties(_ref494, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref495, _ref496, children);
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref499 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload20 = /*#__PURE__*/React.forwardRef(function CloudUpload20(_ref497, ref) {
  var children = _ref497.children,
      rest = _objectWithoutProperties(_ref497, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref498, _ref499, children);
});

var _ref501 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
});

var _ref502 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
});

var CloudUpload16 = /*#__PURE__*/React.forwardRef(function CloudUpload16(_ref500, ref) {
  var children = _ref500.children,
      rest = _objectWithoutProperties(_ref500, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref501, _ref502, children);
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp32 = /*#__PURE__*/React.forwardRef(function CloudApp32(_ref503, ref) {
  var children = _ref503.children,
      rest = _objectWithoutProperties(_ref503, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp24 = /*#__PURE__*/React.forwardRef(function CloudApp24(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, children);
});

var _ref508 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp20 = /*#__PURE__*/React.forwardRef(function CloudApp20(_ref507, ref) {
  var children = _ref507.children,
      rest = _objectWithoutProperties(_ref507, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref508, children);
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
});

var CloudApp16 = /*#__PURE__*/React.forwardRef(function CloudApp16(_ref509, ref) {
  var children = _ref509.children,
      rest = _objectWithoutProperties(_ref509, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref510, children);
});

var _ref512 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var _ref513 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
});

var CloudFoundry_132 = /*#__PURE__*/React.forwardRef(function CloudFoundry_132(_ref511, ref) {
  var children = _ref511.children,
      rest = _objectWithoutProperties(_ref511, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref512, _ref513, children);
});

var _ref515 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var _ref516 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
});

var CloudFoundry_124 = /*#__PURE__*/React.forwardRef(function CloudFoundry_124(_ref514, ref) {
  var children = _ref514.children,
      rest = _objectWithoutProperties(_ref514, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref515, _ref516, children);
});

var _ref518 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var _ref519 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
});

var CloudFoundry_120 = /*#__PURE__*/React.forwardRef(function CloudFoundry_120(_ref517, ref) {
  var children = _ref517.children,
      rest = _objectWithoutProperties(_ref517, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref518, _ref519, children);
});

var _ref521 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
});

var _ref522 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
});

var CloudFoundry_116 = /*#__PURE__*/React.forwardRef(function CloudFoundry_116(_ref520, ref) {
  var children = _ref520.children,
      rest = _objectWithoutProperties(_ref520, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref521, _ref522, children);
});

var _ref524 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
});

var CloudFoundry_232 = /*#__PURE__*/React.forwardRef(function CloudFoundry_232(_ref523, ref) {
  var children = _ref523.children,
      rest = _objectWithoutProperties(_ref523, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref524, children);
});

var _ref526 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
});

var CloudFoundry_224 = /*#__PURE__*/React.forwardRef(function CloudFoundry_224(_ref525, ref) {
  var children = _ref525.children,
      rest = _objectWithoutProperties(_ref525, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref526, children);
});

var _ref528 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
});

var CloudFoundry_220 = /*#__PURE__*/React.forwardRef(function CloudFoundry_220(_ref527, ref) {
  var children = _ref527.children,
      rest = _objectWithoutProperties(_ref527, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref528, children);
});

var _ref530 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
});

var CloudFoundry_216 = /*#__PURE__*/React.forwardRef(function CloudFoundry_216(_ref529, ref) {
  var children = _ref529.children,
      rest = _objectWithoutProperties(_ref529, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref530, children);
});

var _ref532 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "20",
  r: "2"
});

var _ref533 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
});

var _ref534 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "12",
  r: "2"
});

var _ref535 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,24.7588l-7,4.0835L5,22.4258V9.5742L16,3.1577,27,9.5742V22h2V9a1,1,0,0,0-.4961-.8638l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0L24,26.4907Z"
});

var CloudSatellite32 = /*#__PURE__*/React.forwardRef(function CloudSatellite32(_ref531, ref) {
  var children = _ref531.children,
      rest = _objectWithoutProperties(_ref531, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref532, _ref533, _ref534, _ref535, children);
});

var _ref537 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "20",
  r: "2"
});

var _ref538 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
});

var _ref539 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "12",
  r: "2"
});

var _ref540 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,24.7588l-7,4.0835L5,22.4258V9.5742L16,3.1577,27,9.5742V22h2V9a1,1,0,0,0-.4961-.8638l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0L24,26.4907Z"
});

var CloudSatellite24 = /*#__PURE__*/React.forwardRef(function CloudSatellite24(_ref536, ref) {
  var children = _ref536.children,
      rest = _objectWithoutProperties(_ref536, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref537, _ref538, _ref539, _ref540, children);
});

var _ref542 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "20",
  r: "2"
});

var _ref543 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
});

var _ref544 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "12",
  r: "2"
});

var _ref545 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,24.7588l-7,4.0835L5,22.4258V9.5742L16,3.1577,27,9.5742V22h2V9a1,1,0,0,0-.4961-.8638l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0L24,26.4907Z"
});

var CloudSatellite20 = /*#__PURE__*/React.forwardRef(function CloudSatellite20(_ref541, ref) {
  var children = _ref541.children,
      rest = _objectWithoutProperties(_ref541, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref542, _ref543, _ref544, _ref545, children);
});

var _ref547 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9",
  cy: "20",
  r: "2"
});

var _ref548 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
});

var _ref549 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "12",
  r: "2"
});

var _ref550 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,24.7588l-7,4.0835L5,22.4258V9.5742L16,3.1577,27,9.5742V22h2V9a1,1,0,0,0-.4961-.8638l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0L24,26.4907Z"
});

var CloudSatellite16 = /*#__PURE__*/React.forwardRef(function CloudSatellite16(_ref546, ref) {
  var children = _ref546.children,
      rest = _objectWithoutProperties(_ref546, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref547, _ref548, _ref549, _ref550, children);
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
});

var Cloudy32 = /*#__PURE__*/React.forwardRef(function Cloudy32(_ref551, ref) {
  var children = _ref551.children,
      rest = _objectWithoutProperties(_ref551, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref552, children);
});

var _ref554 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
});

var Cloudy24 = /*#__PURE__*/React.forwardRef(function Cloudy24(_ref553, ref) {
  var children = _ref553.children,
      rest = _objectWithoutProperties(_ref553, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref554, children);
});

var _ref556 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
});

var Cloudy20 = /*#__PURE__*/React.forwardRef(function Cloudy20(_ref555, ref) {
  var children = _ref555.children,
      rest = _objectWithoutProperties(_ref555, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref556, children);
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
});

var Cloudy16 = /*#__PURE__*/React.forwardRef(function Cloudy16(_ref557, ref) {
  var children = _ref557.children,
      rest = _objectWithoutProperties(_ref557, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref558, children);
});

var _ref560 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
});

var WatsonHealthCobbAngle32 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle32(_ref559, ref) {
  var children = _ref559.children,
      rest = _objectWithoutProperties(_ref559, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref560, children);
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
});

var WatsonHealthCobbAngle24 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle24(_ref561, ref) {
  var children = _ref561.children,
      rest = _objectWithoutProperties(_ref561, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref562, children);
});

var _ref564 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
});

var WatsonHealthCobbAngle20 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle20(_ref563, ref) {
  var children = _ref563.children,
      rest = _objectWithoutProperties(_ref563, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref564, children);
});

var _ref566 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
});

var WatsonHealthCobbAngle16 = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle16(_ref565, ref) {
  var children = _ref565.children,
      rest = _objectWithoutProperties(_ref565, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref566, children);
});

var _ref568 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
});

var _ref569 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.91 15H26.080000000000002V17H5.91z",
  transform: "rotate(-75 15.996 16)"
});

var Code32 = /*#__PURE__*/React.forwardRef(function Code32(_ref567, ref) {
  var children = _ref567.children,
      rest = _objectWithoutProperties(_ref567, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref568, _ref569, children);
});

var _ref571 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
});

var _ref572 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.91 15H26.080000000000002V17H5.91z",
  transform: "rotate(-75 15.996 16)"
});

var Code24 = /*#__PURE__*/React.forwardRef(function Code24(_ref570, ref) {
  var children = _ref570.children,
      rest = _objectWithoutProperties(_ref570, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref571, _ref572, children);
});

var _ref574 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
});

var _ref575 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.91 15H26.080000000000002V17H5.91z",
  transform: "rotate(-75 15.996 16)"
});

var Code20 = /*#__PURE__*/React.forwardRef(function Code20(_ref573, ref) {
  var children = _ref573.children,
      rest = _objectWithoutProperties(_ref573, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref574, _ref575, children);
});

var _ref577 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.91 15H26.080000000000002V17H5.91z",
  transform: "rotate(-75 15.996 16)"
});

var Code16 = /*#__PURE__*/React.forwardRef(function Code16(_ref576, ref) {
  var children = _ref576.children,
      rest = _objectWithoutProperties(_ref576, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref577, _ref578, children);
});

var _ref580 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
});

var _ref581 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
  transform: "rotate(-74.995 16.96 10)"
});

var _ref582 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
});

var CodeReference32 = /*#__PURE__*/React.forwardRef(function CodeReference32(_ref579, ref) {
  var children = _ref579.children,
      rest = _objectWithoutProperties(_ref579, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref580, _ref581, _ref582, children);
});

var _ref584 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
});

var _ref585 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
  transform: "rotate(-74.995 16.96 10)"
});

var _ref586 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
});

var CodeReference24 = /*#__PURE__*/React.forwardRef(function CodeReference24(_ref583, ref) {
  var children = _ref583.children,
      rest = _objectWithoutProperties(_ref583, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref584, _ref585, _ref586, children);
});

var _ref588 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
});

var _ref589 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
  transform: "rotate(-74.995 16.96 10)"
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
});

var CodeReference20 = /*#__PURE__*/React.forwardRef(function CodeReference20(_ref587, ref) {
  var children = _ref587.children,
      rest = _objectWithoutProperties(_ref587, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref588, _ref589, _ref590, children);
});

var _ref592 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
});

var _ref593 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
  transform: "rotate(-74.995 16.96 10)"
});

var _ref594 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
});

var CodeReference16 = /*#__PURE__*/React.forwardRef(function CodeReference16(_ref591, ref) {
  var children = _ref591.children,
      rest = _objectWithoutProperties(_ref591, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref592, _ref593, _ref594, children);
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
});

var Cognitive32 = /*#__PURE__*/React.forwardRef(function Cognitive32(_ref595, ref) {
  var children = _ref595.children,
      rest = _objectWithoutProperties(_ref595, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref596, children);
});

var _ref598 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
});

var Cognitive24 = /*#__PURE__*/React.forwardRef(function Cognitive24(_ref597, ref) {
  var children = _ref597.children,
      rest = _objectWithoutProperties(_ref597, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref598, children);
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
});

var Cognitive20 = /*#__PURE__*/React.forwardRef(function Cognitive20(_ref599, ref) {
  var children = _ref599.children,
      rest = _objectWithoutProperties(_ref599, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
});

var Cognitive16 = /*#__PURE__*/React.forwardRef(function Cognitive16(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, children);
});

var _ref604 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
});

var Collaborate32 = /*#__PURE__*/React.forwardRef(function Collaborate32(_ref603, ref) {
  var children = _ref603.children,
      rest = _objectWithoutProperties(_ref603, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref604, children);
});

var _ref606 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
});

var Collaborate24 = /*#__PURE__*/React.forwardRef(function Collaborate24(_ref605, ref) {
  var children = _ref605.children,
      rest = _objectWithoutProperties(_ref605, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref606, children);
});

var _ref608 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
});

var Collaborate20 = /*#__PURE__*/React.forwardRef(function Collaborate20(_ref607, ref) {
  var children = _ref607.children,
      rest = _objectWithoutProperties(_ref607, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref608, children);
});

var _ref610 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
});

var Collaborate16 = /*#__PURE__*/React.forwardRef(function Collaborate16(_ref609, ref) {
  var children = _ref609.children,
      rest = _objectWithoutProperties(_ref609, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref610, children);
});

var _ref612 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref613 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref614 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
});

var CollapseAll32 = /*#__PURE__*/React.forwardRef(function CollapseAll32(_ref611, ref) {
  var children = _ref611.children,
      rest = _objectWithoutProperties(_ref611, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref612, _ref613, _ref614, children);
});

var _ref616 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref617 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref618 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
});

var CollapseAll24 = /*#__PURE__*/React.forwardRef(function CollapseAll24(_ref615, ref) {
  var children = _ref615.children,
      rest = _objectWithoutProperties(_ref615, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref616, _ref617, _ref618, children);
});

var _ref620 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref621 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref622 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
});

var CollapseAll20 = /*#__PURE__*/React.forwardRef(function CollapseAll20(_ref619, ref) {
  var children = _ref619.children,
      rest = _objectWithoutProperties(_ref619, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref620, _ref621, _ref622, children);
});

var _ref624 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref625 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
});

var _ref626 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
});

var CollapseAll16 = /*#__PURE__*/React.forwardRef(function CollapseAll16(_ref623, ref) {
  var children = _ref623.children,
      rest = _objectWithoutProperties(_ref623, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref624, _ref625, _ref626, children);
});

var _ref628 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
});

var CollapseCategories32 = /*#__PURE__*/React.forwardRef(function CollapseCategories32(_ref627, ref) {
  var children = _ref627.children,
      rest = _objectWithoutProperties(_ref627, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref628, children);
});

var _ref630 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
});

var CollapseCategories24 = /*#__PURE__*/React.forwardRef(function CollapseCategories24(_ref629, ref) {
  var children = _ref629.children,
      rest = _objectWithoutProperties(_ref629, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref630, children);
});

var _ref632 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
});

var CollapseCategories20 = /*#__PURE__*/React.forwardRef(function CollapseCategories20(_ref631, ref) {
  var children = _ref631.children,
      rest = _objectWithoutProperties(_ref631, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref632, children);
});

var _ref634 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
});

var CollapseCategories16 = /*#__PURE__*/React.forwardRef(function CollapseCategories16(_ref633, ref) {
  var children = _ref633.children,
      rest = _objectWithoutProperties(_ref633, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref634, children);
});

var _ref636 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "12",
  r: "2"
});

var _ref637 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "9",
  r: "2"
});

var _ref638 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "12",
  r: "2"
});

var _ref639 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "18",
  r: "2"
});

var _ref640 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "23",
  r: "2"
});

var _ref641 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
});

var ColorPalette32 = /*#__PURE__*/React.forwardRef(function ColorPalette32(_ref635, ref) {
  var children = _ref635.children,
      rest = _objectWithoutProperties(_ref635, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref636, _ref637, _ref638, _ref639, _ref640, _ref641, children);
});

var _ref643 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "12",
  r: "2"
});

var _ref644 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "9",
  r: "2"
});

var _ref645 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "12",
  r: "2"
});

var _ref646 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "18",
  r: "2"
});

var _ref647 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "23",
  r: "2"
});

var _ref648 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
});

var ColorPalette24 = /*#__PURE__*/React.forwardRef(function ColorPalette24(_ref642, ref) {
  var children = _ref642.children,
      rest = _objectWithoutProperties(_ref642, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref643, _ref644, _ref645, _ref646, _ref647, _ref648, children);
});

var _ref650 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "12",
  r: "2"
});

var _ref651 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "9",
  r: "2"
});

var _ref652 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "12",
  r: "2"
});

var _ref653 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "18",
  r: "2"
});

var _ref654 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "23",
  r: "2"
});

var _ref655 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
});

var ColorPalette20 = /*#__PURE__*/React.forwardRef(function ColorPalette20(_ref649, ref) {
  var children = _ref649.children,
      rest = _objectWithoutProperties(_ref649, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref650, _ref651, _ref652, _ref653, _ref654, _ref655, children);
});

var _ref657 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "12",
  r: "2"
});

var _ref658 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "16",
  cy: "9",
  r: "2"
});

var _ref659 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22",
  cy: "12",
  r: "2"
});

var _ref660 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "23",
  cy: "18",
  r: "2"
});

var _ref661 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "19",
  cy: "23",
  r: "2"
});

var _ref662 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
});

var ColorPalette16 = /*#__PURE__*/React.forwardRef(function ColorPalette16(_ref656, ref) {
  var children = _ref656.children,
      rest = _objectWithoutProperties(_ref656, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref657, _ref658, _ref659, _ref660, _ref661, _ref662, children);
});

var _ref664 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
});

var ColorSwitch32 = /*#__PURE__*/React.forwardRef(function ColorSwitch32(_ref663, ref) {
  var children = _ref663.children,
      rest = _objectWithoutProperties(_ref663, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref664, children);
});

var _ref666 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
});

var ColorSwitch24 = /*#__PURE__*/React.forwardRef(function ColorSwitch24(_ref665, ref) {
  var children = _ref665.children,
      rest = _objectWithoutProperties(_ref665, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref666, children);
});

var _ref668 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
});

var ColorSwitch20 = /*#__PURE__*/React.forwardRef(function ColorSwitch20(_ref667, ref) {
  var children = _ref667.children,
      rest = _objectWithoutProperties(_ref667, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref668, children);
});

var _ref670 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
});

var ColorSwitch16 = /*#__PURE__*/React.forwardRef(function ColorSwitch16(_ref669, ref) {
  var children = _ref669.children,
      rest = _objectWithoutProperties(_ref669, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref670, children);
});

export { ChatBot16, ChatBot20, Checkbox16, Checkbox20, Checkbox24, Checkbox32, CheckboxChecked16, CheckboxChecked20, CheckboxChecked24, CheckboxChecked32, CheckboxCheckedFilled16, CheckboxCheckedFilled20, CheckboxCheckedFilled24, CheckboxCheckedFilled32, CheckboxIndeterminate16, CheckboxIndeterminate20, CheckboxIndeterminate24, CheckboxIndeterminate32, CheckboxIndeterminateFilled16, CheckboxIndeterminateFilled20, CheckboxIndeterminateFilled24, CheckboxIndeterminateFilled32, CheckboxUndeterminate16, CheckboxUndeterminate20, CheckboxUndeterminate24, CheckboxUndeterminate32, CheckboxUndeterminateFilled16, CheckboxUndeterminateFilled20, CheckboxUndeterminateFilled24, CheckboxUndeterminateFilled32, Checkmark16, Checkmark20, Checkmark24, Checkmark32, CheckmarkFilled16, CheckmarkFilled20, CheckmarkFilled24, CheckmarkFilled32, CheckmarkFilledError16, CheckmarkFilledError20, CheckmarkFilledError24, CheckmarkFilledError32, CheckmarkFilledWarning16, CheckmarkFilledWarning20, CheckmarkFilledWarning24, CheckmarkFilledWarning32, CheckmarkOutline16, CheckmarkOutline20, CheckmarkOutline24, CheckmarkOutline32, CheckmarkOutlineError16, CheckmarkOutlineError20, CheckmarkOutlineError24, CheckmarkOutlineError32, CheckmarkOutlineWarning16, CheckmarkOutlineWarning20, CheckmarkOutlineWarning24, CheckmarkOutlineWarning32, Chemistry16, Chemistry20, Chemistry24, Chemistry32, ChemistryReference16, ChemistryReference20, ChemistryReference24, ChemistryReference32, ChevronDown16, ChevronDown20, ChevronDown24, ChevronDown32, ChevronDownGlyph, ChevronLeft16, ChevronLeft20, ChevronLeft24, ChevronLeft32, ChevronLeftGlyph, ChevronMini16, ChevronMini20, ChevronMini24, ChevronMini32, ChevronRight16, ChevronRight20, ChevronRight24, ChevronRight32, ChevronRightGlyph, ChevronSort16, ChevronSort20, ChevronSort24, ChevronSort32, ChevronSortDown16, ChevronSortDown20, ChevronSortDown24, ChevronSortDown32, ChevronSortUp16, ChevronSortUp20, ChevronSortUp24, ChevronSortUp32, ChevronUp16, ChevronUp20, ChevronUp24, ChevronUp32, ChevronUpGlyph, Chip16, Chip20, Chip24, Chip32, Choices16, Choices20, Choices24, Choices32, CircleDash16, CircleDash20, CircleDash24, CircleDash32, CircleFilled16, CircleFilled20, CircleFilled24, CircleFilled32, CirclePacking16, CirclePacking20, CirclePacking24, CirclePacking32, Classification16, Classification20, Classification24, Classification32, ClassifierLanguage16, ClassifierLanguage20, ClassifierLanguage24, ClassifierLanguage32, Clean16, Clean20, Clean24, Clean32, Close16, Close20, Close24, Close32, CloseFilled16, CloseFilled20, CloseFilled24, CloseFilled32, CloseOutline16, CloseOutline20, CloseOutline24, CloseOutline32, ClosedCaption16, ClosedCaption20, ClosedCaption24, ClosedCaption32, ClosedCaptionAlt16, ClosedCaptionAlt20, ClosedCaptionAlt24, ClosedCaptionAlt32, ClosedCaptionFilled16, ClosedCaptionFilled20, ClosedCaptionFilled24, ClosedCaptionFilled32, Cloud16, Cloud20, Cloud24, Cloud32, CloudApp16, CloudApp20, CloudApp24, CloudApp32, CloudDataOps16, CloudDataOps20, CloudDataOps24, CloudDataOps32, CloudDownload16, CloudDownload20, CloudDownload24, CloudDownload32, CloudFoundry_116, CloudFoundry_120, CloudFoundry_124, CloudFoundry_132, CloudFoundry_216, CloudFoundry_220, CloudFoundry_224, CloudFoundry_232, CloudLightning16, CloudLightning20, CloudLightning24, CloudLightning32, CloudRain16, CloudRain20, CloudRain24, CloudRain32, CloudSatellite16, CloudSatellite20, CloudSatellite24, CloudSatellite32, CloudSnow16, CloudSnow20, CloudSnow24, CloudSnow32, CloudUpload16, CloudUpload20, CloudUpload24, CloudUpload32, Cloudy16, Cloudy20, Cloudy24, Cloudy32, Code16, Code20, Code24, Code32, CodeReference16, CodeReference20, CodeReference24, CodeReference32, Cognitive16, Cognitive20, Cognitive24, Cognitive32, Collaborate16, Collaborate20, Collaborate24, Collaborate32, CollapseAll16, CollapseAll20, CollapseAll24, CollapseAll32, CollapseCategories16, CollapseCategories20, CollapseCategories24, CollapseCategories32, ColorPalette16, ColorPalette20, ColorPalette24, ColorPalette32, ColorSwitch16, ColorSwitch20, ColorSwitch24, ColorSwitch32, QCircuitComposer16, QCircuitComposer20, QCircuitComposer24, QCircuitComposer32, WatsonHealthCircleMeasurement16, WatsonHealthCircleMeasurement20, WatsonHealthCircleMeasurement24, WatsonHealthCircleMeasurement32, WatsonHealthCobbAngle16, WatsonHealthCobbAngle20, WatsonHealthCobbAngle24, WatsonHealthCobbAngle32 };
